const detectEnvironment = () => {
	if (typeof window !== "undefined") {
		const hostname = window.location.hostname;

		if (hostname === "debugaccess.onlyall.fr") {
			return "preprod";
		}
		if (hostname === "access.onlyall.fr") {
			return "prod";
		}
	}

	return "preprod";
};

const env = detectEnvironment();

const SERV_URL =
	env === "prod"
		? "https://apiv1.onlyall.fr/"
		: "https://onlyallapiv1-preprodapi.azurewebsites.net/";

// Preprod url
// https://onlyallapiv1-preprodapi.azurewebsites.net

const FILES_URL = "https://files.onlyall.fr/";
module.exports = {
	SERV_URL: SERV_URL,
	API_URL: SERV_URL + "api/",
	FILES_URL: FILES_URL,
	PICTOS_URL: FILES_URL + "Pictos/",
	PING_URL: FILES_URL + "ping.png",
};
